import { analytics, PlanFinderEvents } from '@/lib/analytics'

type UsageProfile = 'uniform' | 'seasonal'

interface PlanFinderStartedEventData {
  source: 'plans-banner'
}

interface PlanFinderUsageSelectedEventData {
  usageProfile: UsageProfile
}

interface PlanFinderEnvelopesSelectedEventData {
  usageProfile: UsageProfile
  envelopeOption: string
  desiredEnvelopes: number
}

interface PlanFinderFeaturesSelectedEventData {
  usageProfile: UsageProfile
  selectedFeatures: Array<string>
  desiredEnvelopes: number
}

interface PlanFinderPlanSelectedEventData {
  usageProfile: UsageProfile
  recommendedPlan: string
  selectedRecurrence: 'Monthly' | 'Yearly'
  desiredEnvelopes: number
  selectedFeatures: Array<string>
  monthlyPrice: number
  yearlyPrice: number
  currency: string
}

interface PlanFinderClosedEventData {
  step: number
  usageProfile: UsageProfile | null
}

export function trackPlanFinderStarted(data: PlanFinderStartedEventData): void {
  analytics.track(PlanFinderEvents.STARTED, {
    source: data.source,
  })
}

export function trackPlanFinderUsageSelected(
  data: PlanFinderUsageSelectedEventData,
): void {
  analytics.track(PlanFinderEvents.USAGE_SELECTED, {
    usage_profile: data.usageProfile,
  })
}

export function trackPlanFinderEnvelopesSelected(
  data: PlanFinderEnvelopesSelectedEventData,
): void {
  analytics.track(PlanFinderEvents.ENVELOPES_SELECTED, {
    usage_profile: data.usageProfile,
    envelope_option: data.envelopeOption,
    desired_envelopes: data.desiredEnvelopes,
  })
}

export function trackPlanFinderFeaturesSelected(
  data: PlanFinderFeaturesSelectedEventData,
): void {
  analytics.track(PlanFinderEvents.FEATURES_SELECTED, {
    usage_profile: data.usageProfile,
    selected_features: data.selectedFeatures,
    desired_envelopes: data.desiredEnvelopes,
  })
}

export function trackPlanFinderPlanSelected(
  data: PlanFinderPlanSelectedEventData,
): void {
  analytics.track(PlanFinderEvents.PLAN_SELECTED, {
    usage_profile: data.usageProfile,
    recommended_plan: data.recommendedPlan,
    selected_recurrence: data.selectedRecurrence,
    desired_envelopes: data.desiredEnvelopes,
    selected_features: data.selectedFeatures,
    monthly_price: data.monthlyPrice,
    yearly_price: data.yearlyPrice,
    currency: data.currency,
  })
}

export function trackPlanFinderClosed(data: PlanFinderClosedEventData): void {
  analytics.track(PlanFinderEvents.CLOSED, {
    step: data.step,
    usage_profile: data.usageProfile,
  })
}
